import React, { useEffect, useState } from "react";
import { Button, Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { DndProvider} from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ClosingReasonService } from "@frontend/src/core/services/closing_reason_service";
import ClosingReasonModal from "../content/closing_reason_modal/ClosingReasonModal";
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import DragSortingTable from "@frontend/components/settings/DragSortingTable"

const ClosingReasons = () => {
  const [closingReasonsList, setReasonsList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [reasonSelected, setReasonSelected] = useState(null);
  const closingReasonService = new ClosingReasonService();

  const columnList = [
    {
      title: "Nombre",
      dataIndex: "description",
    },
    {
      dataIndex: "",
      align: "center",
      width: 90,
      fixed: "right",
      render: (record) => actions(record),
    },
  ];

  const actions = (closing_reason) => {
    return (
      <div className="actions">
        <span className="action-box">
          <Button
            type="link"
            className="icon-item"
            size="small"
            onClick={() => {
              setReasonSelected(closing_reason);
              setShowModal(true);
            }}
          >
            <EditOutlined />
          </Button>
        </span>
        <span className="action-box">
          <Popconfirm
            title="¿Estás seguro de eliminar el motivo? (El motivo será eliminado de forma permanente)"
            onConfirm={() => deleteReason(closing_reason)}
            onCancel={() => {}}
            okText="Eliminar"
            cancelText="Cancelar"
          >
            <Button type="link" className="icon-item" size="small">
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </span>
      </div>
    );
  };

  function fetchReasons() {
    closingReasonService.getAll(
      (data) => {
        setReasonsList(data);
      },
      (err) => {}
    );
  }

  const onSaveClosingReason = (e, form) => {
    e.preventDefault()
    form.validateFields((_err, values) => reasonSelected ? updateReason(values) : createReason(values));
  };

  const updateReason = (values) => {
    closingReasonService.update(
      reasonSelected.id,
      { closing_reason: values },
      (res) => {
        setReasonsList(
          closingReasonsList.map((item) =>
            item.id === res.id ? { ...res } : item
          )
        );
        setShowModal(false);
        openNotificationWithIcon(
          "success",
          "Motivo actualizado correctamente",
          ""
        );
      },
      (err) => {}
    );
  };

  const updateOrder = (values,id) => {
    closingReasonService.update(
      id,
      { closing_reason: values },
      (res) => {
        return res
      },
      (err) => {}
    );
  };

  const createReason = (values) => {
    values.order = closingReasonsList[closingReasonsList.length+-1].order+1
    closingReasonService.create(
      { closing_reason: values },
      (result) => {
        setReasonsList([...closingReasonsList, result]);
        setShowModal(false);
        openNotificationWithIcon("success", "Motivo creado correctamente", "");
      },
      (err) => {}
    );
  };

  const deleteReason = (value) => {
    closingReasonService.delete(
      value.id,
      () => {
        setReasonsList(
          closingReasonsList.filter((item) => value.id !== item.id)
        );
        setShowModal(false);
        openNotificationWithIcon(
          "success",
          "Motivo eliminado correctamente",
          ""
        );
      },
      (err) => {}
    );
  };

  useEffect(() => {
    fetchReasons();
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <div className={"card settings-card"}>
          <div className="card-header">
            <div className="title">Motivos de cierre de proceso</div>
          </div>
          <div className="card-body">
            <div>
              <DragSortingTable
                columnList={columnList}
                dataList={closingReasonsList}
                setDataList={setReasonsList}
                updateFunction={updateOrder}
              />
            </div>
            <div className="button-add">
              <Button
                onClick={() => {
                  setReasonSelected(null);
                  setShowModal(true);
                }}
              >
                Crear nuevo motivo de cierre
              </Button>
            </div>
          </div>
        </div>
        {showModal && (
          <ClosingReasonModal
            showModal={showModal}
            setShowModal={setShowModal}
            reasonSelected={reasonSelected}
            onSaveClosingReason={onSaveClosingReason}
          />
        )}
      </div>
    </DndProvider>
  );
};

export default ClosingReasons;
